import { DataModelsData, DataModelsState } from '../../../types'

export const SET_DATA_MODELS = 'dataModel//SET_DATA_MODELS'

export interface SetDataModelsAction {
  type: typeof SET_DATA_MODELS
  payload: DataModelsData
}

export type DataModelsAction = SetDataModelsAction

export function setDataModels(data: DataModelsData): SetDataModelsAction {
  return {
    type: SET_DATA_MODELS,
    payload: data,
  }
}

export function getDataModels(store: {
  dataModel: DataModelsState
}): DataModelsData {
  return store.dataModel.data
}

const initialState: DataModelsState = {
  data: {
    salutationsList: [],
    maritalStatusesList: [],
    contractSituations: [],
    countries: [],
    legalTypes: [],
    occupations: [],
    residences: [],
    countryCodes: [],
  },
}

export default function dataModelsReducer(
  state: DataModelsState = initialState,
  action: DataModelsAction
): DataModelsState {
  switch (action.type) {
    case SET_DATA_MODELS:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload,
        },
      }

    default:
      return state
  }
}
